import { Argument } from "classnames";
import css from "styled-jsx/css";
import { Space } from "../Box/useBoxStyles";
import { ResponsiveProp, normaliseResponsiveProp } from "./responsiveProp";

export const MOBILE_MAX_WIDTH = 740;
export const TABLET_MAX_WIDTH = 992;

export function negativeMarginTop(
  space: ResponsiveProp<Space>,
): [Argument, JSX.Element] {
  const [mobilePx, tabletPx, desktopPx] =
    normaliseResponsiveProp(space).map(mapSpace);
  const className = "margin-fix-top";

  const resolved = css.resolve`
    .${className}:before {
      content: "";
      display: block;
      padding-top: 1px;
      margin-top: -${mobilePx + 1}px;
    }
    @media screen and (min-width: ${MOBILE_MAX_WIDTH}px) {
      .${className}:before {
        margin-top: -${tabletPx + 1}px;
      }
    }
    @media screen and (min-width: ${TABLET_MAX_WIDTH}px) {
      .${className}:before {
        margin-top: -${desktopPx + 1}px;
      }
    }
  `;

  return [resolved.className + " " + className, resolved.styles];
}

export function negativeMarginLeft(
  space: ResponsiveProp<Space>,
): [Argument, JSX.Element] {
  const [mobilePx, tabletPx, desktopPx] =
    normaliseResponsiveProp(space).map(mapSpace);
  const className = "margin-fix-left";

  const resolved = css.resolve`
    .${className} {
      margin-left: -${mobilePx}px;
    }
    @media screen and (min-width: ${MOBILE_MAX_WIDTH}px) {
      .${className} {
        margin-left: -${tabletPx}px;
      }
    }
    @media screen and (min-width: ${TABLET_MAX_WIDTH}px) {
      .${className} {
        margin-left: -${desktopPx}px;
      }
    }
  `;

  return [resolved.className + " " + className, resolved.styles];
}

const grid = 5;

function mapSpace(space: Space): number {
  switch (space) {
    case "gutter":
      return 4 * grid;
    case "none":
      return 0;
    default:
      return parseInt(space, 10) * grid;
  }
}
